<template>
  <div id="login">
    <div class="redirecting">
      Redirecting...
    </div>
  </div>
</template>


<script>
import {navigateTo} from "@/router";
import {mapGetters} from "vuex";
import {RouteConstants} from "@/router/routeConstants";
import {OnboardingStatus} from "@/app/utils/common/constants";

export default {
  name: 'Login',
  computed: {
    ...mapGetters('app', ['isAdminMode', 'getMerchantId', 'getSessionPayfac']),
    ...mapGetters('merchantPayfacDetails', ['getOnboardingStatus']),
    isAdmin() {
      return String(this.$router.currentRoute.query.adminMode) === "true"
    },
    isMerchantReadOnly() {
      return !this.isAdmin && Boolean(this.getMerchantId)
    },
  },
  mounted() {
    if (this.getOnboardingStatus(this.getSessionPayfac) !== OnboardingStatus.APPROVED) {
      navigateTo(this.getMerchantId ? RouteConstants.SETUP_PROGRESS : RouteConstants.INCREMENTAL_ONBOARDING)
      return;
    }
    navigateTo(RouteConstants.DASHBOARD);
  }
}
</script>

<style lang="scss">
#login .redirecting {
  font-size: 42px;
  color: $primary_text-dark;
  margin-top: 52px;
}
</style>